import { render, staticRenderFns } from "./childAgeTab.vue?vue&type=template&id=0701c1f6&"
import script from "./childAgeTab.vue?vue&type=script&lang=js&"
export * from "./childAgeTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports